import React, { useState,useEffect } from 'react';
import Select from 'react-select';
import { allDoorDevicesSelect } from 'network/ApiAxiosAutomation';

function SearchSelectDoorDevices(props) {
    useEffect(() => {
        getDoors()
    }, []);

    const [selectedOption, setSelectedOption] = useState(null);
    const [options, setOptions] = useState();

    const getDoors = async()=>{
        const resp = await allDoorDevicesSelect()
        if (resp.data.success){
            setOptions(resp.data.doors)
        }
    }

    return (
      <div className="mb-2">
        <Select
          defaultValue={selectedOption}
          onChange={props.onSelect}
          options={options}
          isSearchable={true}
        />
      </div>
    )
}

export default SearchSelectDoorDevices